import { supabase } from '../../lib/supabase';

export interface ToolBasic {
  id: string;
  title: string;
  logo_url: string | null;
  description: string;
  tool_url: string;
}

// Get all tools
export const fetchAllTools = async (): Promise<ToolBasic[]> => {
  try {
    const { data, error } = await supabase
      .from('ai_tools')
      .select('id, title, logo_url, description, tool_url');
    
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching tools:', error);
    throw error;
  }
};

// Get tools for a specific class
export const getClassTools = async (classId: string): Promise<ToolBasic[]> => {
  try {
    const { data, error } = await supabase
      .from('class_tools')
      .select(`
        tool_id,
        ai_tools:tool_id (id, title, logo_url, description, tool_url)
      `)
      .eq('class_id', classId);
    
    if (error) throw error;
    
    // Transform data to return just the tool objects
    return (data || []).map((item: any) => item.ai_tools).filter(Boolean);
  } catch (error) {
    console.error('Error fetching class tools:', error);
    throw error;
  }
};

// Attach tools to a class
export const attachToolsToClass = async (classId: string, toolIds: string[]): Promise<void> => {
  try {
    // First, remove all existing associations
    const { error: deleteError } = await supabase
      .from('class_tools')
      .delete()
      .eq('class_id', classId);
    
    if (deleteError) throw deleteError;
    
    // Skip if no tools to add
    if (toolIds.length === 0) return;
    
    // Create new associations
    const associations = toolIds.map(toolId => ({
      class_id: classId,
      tool_id: toolId
    }));
    
    const { error: insertError } = await supabase
      .from('class_tools')
      .insert(associations);
    
    if (insertError) throw insertError;
  } catch (error) {
    console.error('Error attaching tools to class:', error);
    throw error;
  }
};

// Update the ClassData interface to include tools
export const updateClassWithTools = async (classId: string, toolIds: string[]): Promise<void> => {
  return attachToolsToClass(classId, toolIds);
}; 